import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export interface VatReleaseReasonItem {
    readonly id: number;
    readonly name: string;
    readonly customReleaseName: boolean;
}

interface VatReleaseReasonInternalItem {
    readonly id: number;
    readonly name: string;
    readonly customizable: boolean;
}

export class VatReleaseReasonQuery extends Query<VatReleaseReasonItem[]> { }

export class VatReleaseReasonQueryHandlerBase implements QueryHandler<VatReleaseReasonQuery, VatReleaseReasonItem[]> {
    public static Url = TaggedUrl.join('myCompany/vatReleaseReasons', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: VatReleaseReasonQuery): Promise<VatReleaseReasonItem[]> {
        const { data } = await this.http.get<{ items: VatReleaseReasonInternalItem[] }>(VatReleaseReasonQueryHandlerBase.Url);
        return data.items
            .map(item => ({
                id: item.id,
                name: item.name,
                customReleaseName: item.customizable
            }))
            .sort((a, b) => Number(a.customReleaseName) - Number(b.customReleaseName));
    }
}
